export default {
  PageName: 'POP Information',
  SearchPlaceholder: 'Search for hostname/name',
  hostname: 'Hostname',
  type: 'Type',
  machineStatus: 'Machine Status',
  runningStatus: 'Running Status',
  location: 'Location',
  nets: 'Nets',
  PublicIP: 'Public IP',
  name: 'name',
  area: 'area',
  address: 'address',
  serviceProvider: 'Service Provider',
}